export enum ClipboardAction {
  Cut = 'Cut',
  Copy = 'Copy',
}